import React from 'react';
import ReactDOM from 'react-dom';
import App from './Containers/App';
import { ChakraProvider } from '@chakra-ui/react';
import { theme } from './theme';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './configureStore';
import TagManager from 'react-gtm-module'
import configuration from './Containers/services/configuration';

if(configuration.GTM_ID) {

  const tagManagerArgs = {
    gtmId: configuration.GTM_ID
  }

  TagManager.initialize(tagManagerArgs)
}


const defaultdata = {
  apiKey: null,
  button: false
};

const retrieveParam = (urlToParse, key) => {
      // if (urlToParse.length > 0)
      try {
        let url = new URL(urlToParse);
        let paramVal = url.searchParams.get(key);

        return paramVal;
      } catch (e) {
        return null;
      }
};

if(window && window.location) {

  var anchor_key_value = null;
  var customer_code_value = null;
  var company_pan_value = null;
  const { href } = window.location;
  const anchor_key = retrieveParam(href, "anchor_key") || undefined;
  const customer_code = retrieveParam(href, "customer_code") || undefined;
  const company_pan = retrieveParam(href, "cid") || undefined;
  
  if(anchor_key){
    //localStorage.setItem('anchor_key', anchor_key);
    anchor_key_value = anchor_key;
  }
  /*else if(localStorage.getItem('anchor_key')){
    anchor_key_value = localStorage.getItem('anchor_key');
  }*/


  if(customer_code){
    //localStorage.setItem('customer_code', customer_code);
    customer_code_value = customer_code;
  }
  /*else if(localStorage.getItem('customer_code')){
    customer_code_value = localStorage.getItem('customer_code');
  }*/

  if(anchor_key_value) {
    defaultdata.apiKey = anchor_key_value;
  }

  const panRegex = /^([a-zA-Z]){3}([cphfatbljgCPHFATBLJG])([a-zA-Z]){1}([0-9]){4}([a-zA-Z]){1}$/;
  
  if(company_pan ) {
    
    try {
      // Decode company_pan from base64
      const decodedPAN = atob(company_pan);

      // Check if decodedPAN matches the PAN regex
      if (panRegex.test(decodedPAN)) {
        // Assign to defaultdata.companyPan if regex matches
        defaultdata.companyPan = decodedPAN;
      } else {
        console.log("PAN does not match the regex pattern");
      }
    } catch (error) {
      console.error("Error decoding PAN:", error);
    }

  }

  if(customer_code_value) {
    defaultdata.customerCode = customer_code_value;
  }

}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider theme={theme} >
  	  	<App defaultdata={defaultdata} />
  	  </ChakraProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
